import React from "react";

const ImportantNoteSection = () => {
  const notes = [
    "All hotel payments are made directly by participants",
    "JSA only assists with coordination and verified references",
    "Travel tickets (flight/train/bus) are to be booked by participants",
    "Dedicated emergency support is active throughout the event",
  ];

  return (
    <section className="section-padding">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10 col-md-12">
            <div
              className="services-card important-note-card"
              style={{
                background: "#fff",
                borderRadius: "15px",
                padding: "40px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                borderLeft: "4px solid #F2BC00",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "15px", marginBottom: "25px" }}>
                <div style={{ width: "50px", height: "50px", borderRadius: "10px", background: "#F2BC00", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <i className="fa fa-exclamation-triangle" style={{ fontSize: "24px", color: "#fff" }}></i>
                </div>
                <h3 style={{ margin: 0, fontSize: "24px", fontWeight: "bold", color: "#333" }}>
                  Important Note for Outstation Participants
                </h3>
              </div>
              <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                {notes.map((note, idx) => (
                  <li
                    key={idx}
                    style={{
                      marginBottom: "15px",
                      padding: "15px",
                      background: "#f8f9fa",
                      borderRadius: "10px",
                      fontSize: "16px",
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "12px",
                      color: "#525252",
                    }}
                  >
                    <i className="fa fa-check-circle" style={{ fontSize: "18px", marginTop: "2px", flexShrink: 0, color: "#F2BC00" }}></i>
                    <span>{note}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImportantNoteSection;

